<section
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'card'"
    class="flex flex-col gap-y-5 h-full"
>
    <h3
        class="text-white tl-weekly-brief-summary-title m-0 iq-md"
        [cargoMd]="briefTitle()"
    ></h3>
    <h4
        class="text-white tl-weekly-brief-summary font-normal pb-4 m-0 iq-md"
        [cargoMd]="briefDescription()"
    ></h4>
    <a
        class="text-dat-blue-500 tl-weekly-brief-read-more  uppercase no-underline hover:underline"
        href="https://www.dat.com/blog"
        target="_parent"
        >Read More</a
    >
</section>
<meta name="description" [content]="briefDescription()" />
